export default "__VITE_ASSET__Csx0U$mF__"